export default {
  code: 'Code',
  description: 'Description',
  missing_permissions: 'Missing permissions',
  parameter: 'Parameter',
  traceback: 'Debug information'
};
